import { call, put, takeLatest } from "redux-saga/effects";
import { actions, triggerOnboardingRedirect } from "./slice";
import * as API from "../../../services/apis";


export function* handleLogin({ payload }) {
  try {
    const res = yield call(API.login, payload);
    const { data } = res;
    yield put(actions.fetchLoggedInUser());
    yield put(actions.loginSuccess(data));
  } catch (err) {
    const errorResponse = err?.response;
    const errorData = errorResponse?.data;
    
    // Check if user requires onboarding (user doesn't exist in system)
    if (errorResponse?.status === 401 && errorData?.requiresOnboarding) {
      // FZ-1499: Dispatch onboarding redirect action with prefill data
      const prefill = errorData?.ssoUserInfo || { email: errorData?.email || payload?.username || '' };
      yield put(triggerOnboardingRedirect(prefill));
      return;
    }
    
    yield put(actions.loginFailure(errorData));
  }
}

export function* handleLogout() {
  try {
    const res = yield call(API.logout);
    const { data } = res;
    localStorage.removeItem("pdfServiceToken");
    yield put(actions.logoutSuccess(data));
  } catch (err) {
    localStorage.removeItem("pdfServiceToken");
    yield put(actions.logoutFailure(err?.response?.data));
  }
}

export function* handleFetchLoggedInUser({ payload }) {
  try {
    const res = yield call(API.fetchMyProfile, payload);
    const { data } = res;
    if (data?.data?.document?.pdfServiceToken) {
      localStorage.setItem("pdfServiceToken", data.data.document.pdfServiceToken);
    }
    yield put(actions.fetchLoggedInUserSuccess(data));
  } catch (err) {
    const errorResponse = err?.response;
    const errorData = errorResponse?.data;

    // Check if user requires onboarding (SSO user not registered in FoodLabz)
    if (errorResponse?.status === 401 && errorData?.requiresOnboarding) {
      const prefill = errorData?.ssoUserInfo || { email: errorData?.email || '' };
      yield put(triggerOnboardingRedirect(prefill));
      return;
    }

    yield put(actions.fetchLoggedInUserFailure(errorData));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* authSaga() {
  yield takeLatest(actions.login.type, handleLogin);
  yield takeLatest(actions.logout.type, handleLogout);
  yield takeLatest(actions.fetchLoggedInUser.type, handleFetchLoggedInUser);
}
